import PropTypes from 'prop-types'
import _ from 'lodash'

import { creators as actionCreators } from '.'

export default PropTypes.shape(
  _.mapValues(actionCreators, () => PropTypes.func.isRequired)
).isRequired
